import React, { useEffect, useMemo, useState } from "react";
import classes from './CCTVIntegrationsList.module.css'
import DataManager from "../../hooks/DataManager";
import ListCard from "../../components/GridList/ListCard";
import BasicTable from "../../components/Table/Table/Table";
import GridPaginationControls from "../../components/Table/Table/GridPaginationControls";
import Pill_Widget from "../../components/UI/Widgets/Pill_Widget";
import { useDispatch, useSelector } from 'react-redux';
import Button1 from "../../components/UI/Button/Button1";
import { Await, Link, useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import useSetCookie from "../../components/hooks/UseSetCookie";
import { serviceActions } from "../../store/service-Slice";
import SearchBar from "../SearchView/Search/SearchBar";
import { getGroups, setSiteActive, switchLatch } from "../../Api Methods/Api";
import hikLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hikLogoPortal.png'
import dahuaLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dahuaLogoPortal.png'
import ajaxLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ajaxLogoPortal.png'
import aiboxLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/aiBoxLogoPortal.png'
import camectLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/camectIconPortal.png'
import { id } from "date-fns/locale";
import Pill_Widget_2 from "../../components/UI/Widgets/Pill_Widget_2";
import { color } from "@mui/system";
import { InputSwitch } from "primereact/inputswitch";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import yellowWarn from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/yellow_warn.png'
import amberWarn from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/amber_warn.png'
import redWarn from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/red_warn.png'
import { red } from "@mui/material/colors";
import outputGreenIcon from '../../assets/stateIcons/output_green.png'
import outputRedIcon from '../../assets/stateIcons/output_red.png'
import { getLinkedOutputState } from './linkedOutputState'
import { socket } from '../../Socket/socket'
import parsePinStates from '../../Socket/parsePinStates'


const CCTVIntegrationsList = ({ sites, setSites, refreshSites }) => {
    const [integrations, setIntegrations] = useState(sites);
    console.log(sites);
    const token = useSelector(state => state.auth.token);
    const client = useSelector(state => state.auth.client);
    const userID = useSelector(state => state.auth.userID);
    const apiData = {
        token,
        client
    }

    const dataManager = new DataManager();
    const [searchTerm, setSearchTerm] = useState("");
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const navigate = useNavigate();

    const [checkedSites, setCheckedSites] = useState([]);
    const [selectAllSites, setSelectAllSites] = useState(false);
    const [armDisarmLoading, setArmDisarmLoading] = useState(false);
    const [pinStatesByUUID, setPinStatesByUUID] = useState({});
    const [columnVisibility, setColumnVisibility] = useState(() => JSON.parse(localStorage.getItem('columnVisibility_cctv')) || {});
    const [columnOrder, setColumnOrder] = useState(() => JSON.parse(localStorage.getItem('columnOrder_cctv')) || []);
    const [columnSettingsVisible, setColumnSettingsVisible] = useState(false);

    useEffect(() => {
        setPageIndex(1);
        setCheckedSites([]);
        setSelectAllSites(false);
    }, [sites]);

    // `sites` is the full (unpaginated, potentially thousands-strong) filtered dataset - only
    // request/track live states for the page actually on screen, mirroring DevicesList.js.
    const filteredData = useMemo(() => sites.filter((item) =>
        Object.values(item).some(value => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
    ), [sites, searchTerm]);

    const pageSizeNum = Number(pageSize);
    const pageCount = Math.max(1, Math.ceil(filteredData.length / pageSizeNum));
    const safePageIndex = Math.min(pageIndex, pageCount);

    const pagedData = useMemo(
        () => filteredData.slice((safePageIndex - 1) * pageSizeNum, safePageIndex * pageSizeNum),
        [filteredData, safePageIndex, pageSizeNum]
    );

    useEffect(() => {
        const visibleSiteUUIDS = [];
        for (const site of pagedData) {
            const entries = site.camectEntries ?? [site];
            for (const entry of entries) {
                if (entry.uuid && !visibleSiteUUIDS.includes(entry.uuid)) {
                    visibleSiteUUIDS.push(entry.uuid);
                }
            }
        }

        for (const uuid of visibleSiteUUIDS) {
            socket.emit("routeCommand", {
                cmd: "getStates",
                uuid: uuid
            });
        }
    }, [pagedData]);

    useEffect(() => {
        let buffer = {};
        let flushTimeout = null;

        const flush = () => {
            setPinStatesByUUID((prev) => ({ ...prev, ...buffer }));
            buffer = {};
            flushTimeout = null;
        };

        const HandlePinStates = (data) => {
            buffer[data.uuid] = parsePinStates(data);
            if (!flushTimeout) {
                flushTimeout = setTimeout(flush, 300);
            }
        };

        socket.on('appPinStates', HandlePinStates);

        return () => {
            socket.off('appPinStates', HandlePinStates);
            if (flushTimeout) clearTimeout(flushTimeout);
        };
    }, []);
    const dispatch = useDispatch();
    const HandleUipiodOnClick = (DeviceUUID) => {
        if (DeviceUUID){
            dispatch(serviceActions.setDeviceUUID(DeviceUUID));
            navigate("/Dashboard/SiteView/" + DeviceUUID); 
        }
        useSetCookie("DeviceUUID", DeviceUUID, 1);
    }
    const [groups, setGroups] = useState([])

    useEffect(() => {
        const GetGroups = async () => {
            const groups = await getGroups(apiData, dispatch)
            setGroups(groups)
        }

        GetGroups();
    }, [])

      const HandleSingleDeactivateSite = async (row) => {
        let body = {
          uuid: row.uuid,
          active: row.active == 1 ? 0 : 1
        };
    
        const response = await setSiteActive(apiData, body, dispatch);
        if (response.success){
          setSites((prevSites) =>
            prevSites.map((device) =>
                device.uuid === body.uuid ? { ...device, active: body.active } : device
            )
          );
        }
      }

    // Consolidated multi-Camect rows are grouped by Site ID; individual rows are identified
    // by device + integration + linked pin, since one site can have several integration rows.
    const getRowKey = (item) => item.camectEntries
        ? `group-${item.key}`
        : `${item.uuid}-${item.integrationType}-${item.pinName}-${item.extraField1 ?? ''}`;

    const HandleSiteChecked = (siteObject) => {
        const key = getRowKey(siteObject);
        setCheckedSites(prevChecked => {
            const exists = prevChecked.some(site => getRowKey(site) === key);
            if (exists) return prevChecked.filter(site => getRowKey(site) !== key);
            return [...prevChecked, siteObject];
        });
    }

    const HandleSelectAllSites = () => {
        if (selectAllSites) {
            setSelectAllSites(false);
            setCheckedSites([]);
        } else {
            setSelectAllSites(true);
            setCheckedSites(sites || []);
        }
    }

    const dropdownOptions = ['Arm', 'Disarm'];

    // Mirrors the site_type / country_code option lists in DevicesList.js / Overview.js.
    const siteTypeOptions = [
        { key: 'RESIDENTIAL', label: 'Residential' },
        { key: 'OFFICE', label: 'Office' },
        { key: 'COMMERCIAL', label: 'Commercial' },
        { key: 'INDUSTRIAL', label: 'Industrial' },
        { key: 'CONSTRUCTION', label: 'Construction' },
        { key: 'WAREHOUSE', label: 'Warehouse / Storage' },
        { key: 'EDUCATION', label: 'Education' },
        { key: 'HEALTHCARE', label: 'Healthcare' },
        { key: 'PUBLIC', label: 'Public / Government' },
        { key: 'VACANT', label: 'Vacant property' },
        { key: 'UTILITY', label: 'Utility / Infrastructure' },
        { key: 'OTHER', label: 'Other' }
    ];

    const countryCodeOptions = [
        { code: 'GB', name: 'United Kingdom' },
        { code: 'IE', name: 'Ireland' },
        { code: 'US', name: 'United States' },
        { code: 'CA', name: 'Canada' },
        { code: 'ZA', name: 'South Africa' },
        { code: 'AF', name: 'Afghanistan' },
        { code: 'AL', name: 'Albania' },
        { code: 'DZ', name: 'Algeria' },
        { code: 'AR', name: 'Argentina' },
        { code: 'AU', name: 'Australia' },
        { code: 'AT', name: 'Austria' },
        { code: 'BE', name: 'Belgium' },
        { code: 'BR', name: 'Brazil' },
        { code: 'BG', name: 'Bulgaria' },
        { code: 'CL', name: 'Chile' },
        { code: 'CN', name: 'China' },
        { code: 'CO', name: 'Colombia' },
        { code: 'HR', name: 'Croatia' },
        { code: 'CY', name: 'Cyprus' },
        { code: 'CZ', name: 'Czech Republic' },
        { code: 'DK', name: 'Denmark' },
        { code: 'EE', name: 'Estonia' },
        { code: 'FI', name: 'Finland' },
        { code: 'FR', name: 'France' },
        { code: 'DE', name: 'Germany' },
        { code: 'GR', name: 'Greece' },
        { code: 'HU', name: 'Hungary' },
        { code: 'IS', name: 'Iceland' },
        { code: 'IN', name: 'India' },
        { code: 'ID', name: 'Indonesia' },
        { code: 'IL', name: 'Israel' },
        { code: 'IT', name: 'Italy' },
        { code: 'JP', name: 'Japan' },
        { code: 'KE', name: 'Kenya' },
        { code: 'LV', name: 'Latvia' },
        { code: 'LT', name: 'Lithuania' },
        { code: 'LU', name: 'Luxembourg' },
        { code: 'MY', name: 'Malaysia' },
        { code: 'MT', name: 'Malta' },
        { code: 'MX', name: 'Mexico' },
        { code: 'NL', name: 'Netherlands' },
        { code: 'NZ', name: 'New Zealand' },
        { code: 'NO', name: 'Norway' },
        { code: 'PL', name: 'Poland' },
        { code: 'PT', name: 'Portugal' },
        { code: 'RO', name: 'Romania' },
        { code: 'SA', name: 'Saudi Arabia' },
        { code: 'SG', name: 'Singapore' },
        { code: 'SK', name: 'Slovakia' },
        { code: 'SI', name: 'Slovenia' },
        { code: 'KR', name: 'South Korea' },
        { code: 'ES', name: 'Spain' },
        { code: 'SE', name: 'Sweden' },
        { code: 'CH', name: 'Switzerland' },
        { code: 'TH', name: 'Thailand' },
        { code: 'TR', name: 'Turkey' },
        { code: 'UA', name: 'Ukraine' },
        { code: 'AE', name: 'United Arab Emirates' },
        { code: 'VN', name: 'Vietnam' }
    ];

    // Mirrors PinOutput.js's HandlePinClick: prefer the live socket command, and only
    // fall back to the switchLatch REST call when the socket isn't connected.
    const HandleBulkArmDisarm = async (arm) => {
        // consolidated rows carry several individual Camect entries; act on all of them
        const entries = checkedSites.flatMap(site => site.camectEntries ?? [site]);
        const newState = !arm;

        setArmDisarmLoading(true);
        try {
            await Promise.all(entries.map(entry => {
                const outputState = getLinkedOutputState(entry);
                if (!outputState) return Promise.resolve();

                if (socket.connected) {
                    let cmd = "setState";
                    if (entry.firmware) {
                        const [firmwareMajor, firmwareMinor] = entry.firmware.split('.');
                        if (firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7)) {
                            cmd = "setVirtualState";
                        }
                    }
                    socket.emit("routeCommand", {
                        cmd,
                        allPins: "no",
                        uuid: entry.uuid,
                        pin: outputState.pinKey,
                        state: newState,
                        user: userID,
                        eventID: crypto.randomUUID()
                    });
                    return Promise.resolve();
                }

                return switchLatch(apiData, userID, outputState.pinKey, newState, entry.uuid, outputState.pinType, undefined, dispatch);
            }));
        } finally {
            setArmDisarmLoading(false);
            setCheckedSites([]);
            setSelectAllSites(false);
            refreshSites && refreshSites();
        }
    }

    const setSelectedAction = (action) => {
        switch (action) {
            case 'Arm':
                HandleBulkArmDisarm(true);
                break;
            case 'Disarm':
                HandleBulkArmDisarm(false);
                break;
            default:
                console.warn('Invalid bulk action:', action);
        }
    }
    

    const HandleGroupOnClick = (groupName) => {
        const groupClicked = groups.find(g => g.name === groupName);
        if (groupClicked) {
            sessionStorage.setItem('groupClicked', groupClicked.name)   
            sessionStorage.setItem('groupPath', groupClicked.group_path)
            sessionStorage.setItem('groupClickedID', groupClicked.id)   
            navigate("/Dashboard/Groups/GroupSites")
        }
    }

    const toggleColumnVisibility = (key, currentVisible) => {
        setColumnVisibility(prev => {
            const next = { ...prev, [key]: !currentVisible };
            localStorage.setItem('columnVisibility_cctv', JSON.stringify(next));
            return next;
        });
    };

    const moveColumn = (key, direction) => {
        const naturalOrder = tableColumns.filter(col => col.filterLabel).map(col => col.id);
        setColumnOrder(prev => {
            const current = prev.length ? prev : naturalOrder;
            const idx = current.indexOf(key);
            if (idx === -1) return current;
            const next = [...current];
            const swapIdx = idx + direction;
            if (swapIdx < 0 || swapIdx >= next.length) return current;
            [next[idx], next[swapIdx]] = [next[swapIdx], next[idx]];
            localStorage.setItem('columnOrder_cctv', JSON.stringify(next));
            return next;
        });
    };

    const getDeviceStatus = (missedPolls) => {
        if (missedPolls == 1) return "Connectivity issue detected";
        if (missedPolls == 2) return "Frequent connection issues";
        if (missedPolls >= 3) return "Device offline or unresponsive";
        return "Device stable";
    }

    // Rows representing sites with multiple Camect integrations carry a `camectEntries` array;
    // render one block per associated entry instead of a single value for those rows
    const renderPerEntry = (row, renderItem) => {
        const entries = row.row.original.camectEntries;
        if (!entries || entries.length <= 1) {
            return renderItem(row.row.original);
        }
        return (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                {entries.map((entry, idx) => (
                    <div
                        key={`${entry.uuid}-${entry.extraField1 ?? idx}`}
                        style={{
                            paddingBottom: idx < entries.length - 1 ? "8px" : 0,
                            borderBottom: idx < entries.length - 1 ? "1px solid var(--border-section)" : "none"
                        }}
                    >
                        {renderItem(entry)}
                    </div>
                ))}
            </div>
        );
    };

    let tableColumns = [
        {
            id: "select",
            meta: { style: { width: "40px", minWidth: "40px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <Checkbox onChange={HandleSelectAllSites} checked={selectAllSites} />
                </div>
            ),
            cell: (row) => (
                <div className={classes.tableValueText}>
                    <Checkbox
                        onChange={() => HandleSiteChecked(row.row.original)}
                        checked={checkedSites.some(site => getRowKey(site) === getRowKey(row.row.original))}
                    />
                </div>
            )
        },
        {
            id:"test",
            filterLabel: "Device logo",
            hidden: !(columnVisibility['test'] ?? true),
            meta: { style: { width: "60px", minWidth: "60px" } },
            header: () => <div style={{ width: "20px" }}></div>,
            cell: (row) => renderPerEntry(row, (item) => {
                let logo = ""
                switch (item.integrationType){
                    case "HIKVISION":
                        logo = hikLogo
                        break;
                    case "DAHUA":
                        logo = dahuaLogo
                        break;
                    case "AJAX":
                        logo = ajaxLogo
                        break;
                    case "AIBOX":
                        logo = aiboxLogo
                        break;
                    case "CAMECT":
                        logo = camectLogo
                        break;
                }
                const POLL_INTERVAL_MINUTES = 10;

                const offlineMs = item.missed_polls * POLL_INTERVAL_MINUTES * 60 * 1000;
                const offlineSinceDate = new Date(Date.now() - offlineMs).toLocaleDateString()


                return (
                    <div
                      style={{ maxWidth: "85px", display: "flex", flexDirection: "column", alignItems:"flex-start"}}
                      onClick={() => HandleUipiodOnClick(item.uuid)}
                    >
                      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        {item.missed_polls > 0 && (
                          <img
                            src={
                              item.missed_polls === 1
                                ? yellowWarn
                                : item.missed_polls === 2
                                ? amberWarn
                                : redWarn
                            }
                            style={{ width: "20px", height: "20px", marginRight: "10px" }}
                            title={getDeviceStatus(item.missed_polls)}
                          />
                        )}

                        <img
                          style={{ width: "25px", height: "25px" }}
                          src={logo}
                        />
                      </div>

                      {item.missed_polls > 0 && (
                        <p
                          style={{
                            color: "#6e6e6e",
                            fontSize: "9px",
                            marginTop: "2px",
                            textAlign: "center",
                            fontWeight: 500,
                          }}
                        >
                          {offlineSinceDate}
                        </p>
                      )}
                    </div>
                  );
            })
        },
        {
            id: 'stabilityPercentage',
            filterLabel: "Connection stability",
            hidden: !(columnVisibility['stabilityPercentage'] ?? true),
            meta: { style: { width: "110px", minWidth: "110px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Connection stability</h3>
                </div>
            ),
            accessorKey: 'stabilityPercentage',
            cell: (row) => renderPerEntry(row, (item) => {
                const pct = item.stabilityPercentage;
                if (pct == null || pct === "") {
                    return <div className={classes.tableValueText}>—</div>;
                }
                const num = parseFloat(pct);
                const colour = num >= 90 ? "#27ae60" : num >= 70 ? "#e67e22" : "#c0392b";
                return (
                    <div onClick={() => HandleUipiodOnClick(item.uuid)} className={classes.tableValueText}>
                        { item.integrationType !== "CAMECT" && <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={colour}
                            PillColor_IfFalse={colour}
                            text_IfTrue={`${Math.round(num)}%`}
                            className={classes.PillHeight}
                        />}
                    </div>
                );
            })
        },
        {
            id: 'integrationType',
            filterLabel: "Device",
            hidden: !(columnVisibility['integrationType'] ?? true),
            meta: { style: { width: "90px", minWidth: "90px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Device</h3>
                </div>
            ),
            accessorKey: 'integrationType',
            cell: (row) => {
                let text = ""
                let colour = ""
                let textColour = ""
                switch (row.row.original.integrationType){
                    case "HIKVISION": 
                        text = "Hikvision"
                        colour = "#616366"
                        break;
                    case "DAHUA":
                        text = "Dahua"
                        colour = "#ee0018"
                        break;
                    case "AJAX": 
                        text = "AJAX"
                        colour = "#1a1a1aff"
                        break;
                    case "AIBOX":
                        text = "AIBox"
                        colour = "#00bbf8"
                        break;
                    case "CAMECT":
                        text = "Camect"
                        colour = "#40bd8b"
                        break;
                }
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        <Pill_Widget_2
                            pillColour={colour}
                            textColour={textColour}
                            text={text} 
                        />
                       
                    </div>
                )
            }
        },
        {
            id: 'extraField1',
            filterLabel: "Identifier",
            hidden: !(columnVisibility['extraField1'] ?? true),
            meta: { style: { width: "160px", minWidth: "160px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Identifier</h3>
                </div>
            ),
            accessorKey: 'extraField1',
            cell: (row) => renderPerEntry(row, (item) => (
                <div onClick={() => HandleUipiodOnClick(item.uuid)} className={classes.tableValueText} style={{ whiteSpace: "nowrap" }}>
                    {item.extraField1}
                </div>
            ))
        },
        {
            id: 'tag',
            filterLabel: "Portal name",
            hidden: !(columnVisibility['tag'] ?? true),
            meta: { style: { width: "120px", minWidth: "120px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Portal name</h3>
                </div>
            ),
            accessorKey: 'tag',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
                        {row.row.original.tag && <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={"#919191"}
                            PillColor_IfFalse={"#6e6e6e"}
                            text_IfTrue={row.row.original.tag}
                            className={classes.PillHeight}
                        />}
                    </div>
                )
            }
        },
        {
            id: 'deviceName',
            filterLabel: "App name",
            hidden: !(columnVisibility['deviceName'] ?? true),
            meta: { style: { width: "110px", minWidth: "110px" } },
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>App name</h3>
                </div>
            ),
            accessorKey: 'deviceName',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#C3B1E1"}
                                PillColor_IfFalse={"#626a67"}
                                text_IfTrue={row.row.original.deviceName}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        
        {
            id: 'key',
            filterLabel: "Site ID",
            hidden: !(columnVisibility['key'] ?? true),
            meta: { style: { width: "80px", minWidth: "80px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Site ID</h3>
                </div>
            ),
            accessorKey: 'key',
            cell: (row) => {
                return (
                    <Link
                        to={`/Dashboard/SiteView/${row.row.original.uuid}`}
                        className={classes.tableValueText}
                    >
                        {row.row.original.key}
                    </Link>
                )
            }
        },
        {
            id: 'pinName',
            filterLabel: "Linked output",
            hidden: !(columnVisibility['pinName'] ?? true),
            meta: { style: { width: "110px", minWidth: "110px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Linked output</h3>
                </div>
            ),
            accessorKey: 'pinName',
            cell: (row) => renderPerEntry(row, (item) => (
                <div onClick={() => HandleUipiodOnClick(item.uuid)} className={classes.tableValueText}>
                    {item.pinName}
                </div>
            ))
        },
        {
            id: 'linkedOutputStatus',
            filterLabel: "Status",
            hidden: !(columnVisibility['linkedOutputStatus'] ?? true),
            meta: { style: { width: "90px", minWidth: "90px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Status</h3>
                </div>
            ),
            cell: (row) => renderPerEntry(row, (item) => {
                const liveOutputStates = pinStatesByUUID[item.uuid]?.[0];
                const outputState = getLinkedOutputState(item, liveOutputStates);
                if (!outputState) {
                    return <div className={classes.tableValueText}>—</div>;
                }
                return (
                    <div onClick={() => HandleUipiodOnClick(item.uuid)} className={classes.tableValueText} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <img
                            src={outputState.isOn ? outputRedIcon : outputGreenIcon}
                            style={{ width: "16px", height: "16px" }}
                            title={outputState.label}
                        />
                        {!outputState.isActive && (
                            <i
                                className="pi pi-eye-slash"
                                style={{ fontSize: "14px" }}
                                title="Output not visible in app"
                            />
                        )}
                    </div>
                )
            })
        },
        {
            id: 'lastStateChange',
            filterLabel: "Last state change",
            hidden: !(columnVisibility['lastStateChange'] ?? true),
            meta: { style: { width: "90px", minWidth: "90px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Last state change</h3>
                </div>
            ),
            cell: (row) => renderPerEntry(row, (item) => {
                const liveOutputStates = pinStatesByUUID[item.uuid]?.[0];
                const outputState = getLinkedOutputState(item, liveOutputStates);
                if (!outputState) {
                    return <div className={classes.tableValueText}>—</div>;
                }
                // lastSwitch is a Unix epoch in seconds (backend convention, see UseUnixTimestampConverter.js)
                const formattedLastSwitch = outputState.lastSwitch
                    ? format(new Date(outputState.lastSwitch * 1000), "MMMM do, yyyy - HH:mm")
                    : "—";
                return (
                    <div onClick={() => HandleUipiodOnClick(item.uuid)} className={classes.tableValueText} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <p>{formattedLastSwitch}</p>
                    </div>
                )
            })
        },
        
        {
            id: 'created_at',
            filterLabel: "Date linked",
            hidden: !(columnVisibility['created_at'] ?? true),
            meta: { style: { width: "170px", minWidth: "170px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Date linked</h3>
                </div>
            ),
            accessorKey: 'created_at',
            cell: (row) => renderPerEntry(row, (item) => {
                const formattedDate =
                isNaN(new Date(item.created_at)) ||
                !item.created_at
                  ? item.created_at
                  : format(new Date(item.created_at), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandleUipiodOnClick(item.uuid)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            })
        },
        {
            id: 'missed_polls',
            filterLabel: "Offline since",
            hidden: !(columnVisibility['missed_polls'] ?? true),
            meta: { style: { width: "170px", minWidth: "170px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Offline since</h3>
                </div>
            ),
            accessorKey: 'missed_polls',
            cell: (row) => renderPerEntry(row, (item) => {
                const missedPolls = item.missed_polls;
                if (!missedPolls || missedPolls === 0) {
                    return <div className={classes.tableValueText}>—</div>;
                }
                const POLL_INTERVAL_MINUTES = 10;
                const offlineMs = missedPolls * POLL_INTERVAL_MINUTES * 60 * 1000;
                const offlineSinceDate = format(new Date(Date.now() - offlineMs), "MMMM do, yyyy - HH:mm");
                return (
                    <div onClick={() => HandleUipiodOnClick(item.uuid)} className={classes.tableValueText}>
                        <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={"#c0392b"}
                            PillColor_IfFalse={"#c0392b"}
                            text_IfTrue={offlineSinceDate}
                            className={classes.PillHeight}
                        />
                    </div>
                );
            })
        },
        {
        id: 'name',
        filterLabel: "Site owned by",
        hidden: !(columnVisibility['name'] ?? true),
        meta: { style: { width: "120px", minWidth: "120px" } },
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Site owned by</h3>
            </div>
        ),
        accessorKey: 'name',
        cell: (row) => {
            let companyName = row.row.original.name;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
                    <Pill_Widget
                    boolean={row.row.original.name !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.name}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
            id: 'siteType',
            hidden: !(columnVisibility['siteType'] ?? true),
            meta: { style: { width: "110px", minWidth: "110px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Site type</h3>
                </div>
            ),
            filterLabel: "Site type",
            accessorKey: 'site_type',
            cell: (row) => {
                const siteType = row.row.original.site_type;
                const label = siteTypeOptions.find(o => o.key === siteType)?.label || siteType || "—";
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {label}
                    </div>
                )
            }
        },
        {
            id: 'siteLocation',
            hidden: !(columnVisibility['siteLocation'] ?? true),
            meta: { style: { width: "120px", minWidth: "120px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Site location</h3>
                </div>
            ),
            filterLabel: "Site location",
            accessorKey: 'country_code',
            cell: (row) => {
                const countryCode = row.row.original.country_code;
                const label = countryCodeOptions.find(c => c.code === countryCode)?.name || countryCode || "—";
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {label}
                    </div>
                )
            }
        },
        {
            id: 'Active',
            hidden: !(columnVisibility['Active'] ?? true),
            meta: { style: { width: "90px", minWidth: "90px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                <h3>Active site</h3>
                </div>
            ),
            filterLabel: "Active",
            accessorKey: 'active',
            cell: (row) => {
                const active = row.row.original.active == "1" ? true : false
                return (
                <div className={classes.tableValueText}>
                    <InputSwitch checked={active} onChange={() => HandleSingleDeactivateSite(row.row.original)}/>
                </div>
                )
            }
        },
    ]

    const sortedTableColumns = columnOrder.length
        ? [...tableColumns].sort((a, b) => {
            const ai = columnOrder.indexOf(a.id);
            const bi = columnOrder.indexOf(b.id);
            return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
        })
        : tableColumns;
    const tableColumnsFiltered = sortedTableColumns.filter(column => !column.hidden);

    const columnDefs = (() => {
        const defs = tableColumns
            .filter(col => col.filterLabel)
            .map(col => ({ key: col.id, label: col.filterLabel, visible: !col.hidden }));
        if (!columnOrder.length) return defs;
        return [...defs].sort((a, b) => {
            const ai = columnOrder.indexOf(a.key);
            const bi = columnOrder.indexOf(b.key);
            return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
        });
    })();

    return (
        <div className={`${classes.table} ${classes.center} `}>
            <ListCard secondaryClassName={classes["Card-container"]}>
                <div className={classes["tableCardLayoutUI-wrapper"]} style={{ padding: "5px 10px 0px 10px" }}>
                    <Await resolve={sites}>
                        {() => {
                            return (
                                <>
                                    <Dialog
                                        header="Column visibility"
                                        visible={columnSettingsVisible}
                                        style={{ width: "360px" }}
                                        onHide={() => setColumnSettingsVisible(false)}
                                    >
                                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                            {columnDefs.map(({ key, label, visible }, index, arr) => (
                                                <div key={key} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                                        <Button
                                                            icon="pi pi-angle-up"
                                                            text
                                                            severity="secondary"
                                                            style={{ padding: "2px 4px", width: "24px", height: "20px" }}
                                                            disabled={index === 0}
                                                            onClick={() => moveColumn(key, -1)}
                                                        />
                                                        <Button
                                                            icon="pi pi-angle-down"
                                                            text
                                                            severity="secondary"
                                                            style={{ padding: "2px 4px", width: "24px", height: "20px" }}
                                                            disabled={index === arr.length - 1}
                                                            onClick={() => moveColumn(key, 1)}
                                                        />
                                                    </div>
                                                    <Checkbox
                                                        inputId={`col-${key}`}
                                                        checked={visible}
                                                        onChange={() => toggleColumnVisibility(key, visible)}
                                                    />
                                                    <label htmlFor={`col-${key}`} style={{ cursor: "pointer", fontSize: "14px" }}>{label}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </Dialog>
                                    {checkedSites.length > 0 && (
                                        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px" }}>
                                            <span className={classes.tableValueText}>{checkedSites.length} selected</span>
                                            <Dropdown
                                                placeholder="Select an action"
                                                options={dropdownOptions}
                                                onChange={(e) => setSelectedAction(e.value)}
                                                disabled={armDisarmLoading}
                                            />
                                            {armDisarmLoading && <span className={classes.tableValueText}>Applying...</span>}
                                        </div>
                                    )}
                                    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "4px" }}>
                                        <Button
                                            icon="pi pi-table"
                                            text
                                            severity="secondary"
                                            onClick={() => setColumnSettingsVisible(true)}
                                            title="Show/hide columns"
                                            style={{ padding: "4px 8px" }}
                                        />
                                    </div>
                                    <BasicTable
                                        data={pagedData}
                                        columns={tableColumnsFiltered}
                                        allColumns={tableColumnsFiltered}
                                        filtering={""}
                                        rowClick={false}
                                        ShowPagination={false}
                                        PageSize={pageSizeNum}
                                        paginationOptions={[25, 50, 100]}
                                        showFilterButton={false}
                                        isSortable={false}
                                    />
                                    <GridPaginationControls
                                        pageIndex={safePageIndex}
                                        nextPage={() => setPageIndex(prev => Math.min(prev + 1, pageCount))}
                                        previousPage={() => setPageIndex(prev => Math.max(prev - 1, 1))}
                                        setPageIndex={(idx) => setPageIndex(Math.max(1, Math.min(Number(idx) || 1, pageCount)))}
                                        pageCount={pageCount}
                                        setPageSize={(size) => { setPageSize(Number(size)); setPageIndex(1); }}
                                        PageSize={pageSizeNum}
                                        PaginationOptions={[25, 50, 100]}
                                    />
                                </>
                            );
                        }}
                    </Await>
                </div>
            </ListCard>
        </div>
    );
}

export default CCTVIntegrationsList;